import "./Boats.css";
import axios from 'axios';
import { useEffect, useState } from 'react'
import Table from 'react-bootstrap/Table'
import core from '../../core';
import { Pagination, Stack } from "@mui/material";
import { useDispatch, useSelector } from 'react-redux';
import { notificationActions } from "../../data/notification";
import { Search, ThreeDotsVertical, Plus } from 'react-bootstrap-icons';
import OutsideClickHandler from 'react-outside-click-handler';
import { Button, Modal } from 'react-bootstrap';
import CreateBoat from "./CreateBoat";
import useViewMode from '../../hooks/useViewMode';
import ViewToggle from '../../components/DataView/ViewToggle';
import DataCards from '../../components/DataView/DataCards';
import useT from "../../i18n/useT";

const Boats = () => {
    const t = useT();
    const [filter, setFilter] = useState({limit: 10, page: 1, keyword: "", asc: "desc", status: "", sort_by: "id"})
    const [boats, setBoats] = useState([]);
    const [paginator, setPaginator] = useState({from: 0, to: 0, total: 0, pages: 1});
    const [loading, setLoading] = useState(false);
    const [showBoatsModal, setShowBoatsModal] = useState(false);
    const [formData, setFormData] = useState({name: "", surname: "", superviser_fee: "", email: "", username: "", phone: "", password: "", calculator_category: "", role: "", identity_number: ""})
    const dispatch = useDispatch();
    const lang = useSelector((state) => state.user.language);
    const [createdBoatsCount, setCreatedBoatsCount] = useState(0);
    const [loadingCreateBoat, setLoadingCreateBoat] = useState(false);
    const [keyword, setKeyword] = useState("");
    const [actionsId, setActionsId] = useState("");
    const [actionType, setActionType] = useState("add");
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const {view, setView, isMobile} = useViewMode("boats-view");

    const rowActions = (boat) => (
        <div className='table-actions-block'>
            <ThreeDotsVertical height={"19px"} onClick={() => setActionsId(boat.id)} style={{cursor: "pointer"}}/>
            {actionsId === boat.id && <OutsideClickHandler onOutsideClick={() => setActionsId("")}>
                <div className='table-actions-dropdown'>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");

                    }}>{t("status.warehouse")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setFormData({...boat});
                        setShowBoatsModal(true);
                    }}>{t("boats.onWay")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setActionType("edit");
                        setFormData({...boat});
                        setShowBoatsModal(true);
                    }}>{t("status.arrived")}</div>
                    <div className='table-actions-item' onClick={() => {
                        setActionsId("");
                        setFormData({...boat});
                        setShowConfirmationModal(true);
                    }}>{t("common.delete")}</div>
                </div>
            </OutsideClickHandler>}
        </div>
    );

    const cardFields = [
        {label: t("boats.id"), value: (boat) => boat.id},
        {label: t("boats.identificationCode"), value: (boat) => boat.identification_code},
        {label: t("boats.estDepartureDate"), value: (boat) => boat.departure_date == null ? t("table.notDefined") : core.formdatDate(boat.departure_date, "yyyy-mm-dd")},
        {label: t("boats.estArrivalDate"), value: (boat) => boat.estimated_arrival_date == null ? t("table.notDefined") : core.formdatDate(boat.estimated_arrival_date, "yyyy-mm-dd")},
        {label: t("boats.arrivalDate"), value: (boat) => boat.arrival_date == null ? t("table.notDefined") : core.formdatDate(boat.arrival_date, "yyyy-mm-dd")},
        {label: t("boats.status"), value: (boat) => boat.status.replaceAll("_", " ")},
    ];

    const handlers = {
        createBoat(e){
            e.preventDefault();
            setLoadingCreateBoat(true);
            axios.post('/api/boats', formData)
                .then((res) => {
                    setShowBoatsModal(false);
                    setLoadingCreateBoat(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedBoatsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}));
                    setLoadingCreateBoat(false);
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        modifyBoatStatus(e){
            e.preventDefault();
            setLoadingCreateBoat(true);
            axios.put(`/api/users/${formData.id}`, formData)
                .then((res) => {
                    setLoadingCreateBoat(false);
                    setShowBoatsModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedBoatsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateBoat(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "error-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        },
        deleteBoat(){
            setLoadingCreateBoat(true);
            axios.delete(`/api/users/${formData.id}`)
                .then((res) => {
                    setLoadingCreateBoat(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: res.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                    setCreatedBoatsCount((prev) => prev + 1)
                })
                .catch((err) => {
                    setLoadingCreateBoat(false);
                    setShowConfirmationModal(false);
                    dispatch(notificationActions.changeNotification({show: true, text: err.response.data.message[lang], type: "success-notification"}))
                    setTimeout(() => {
                        dispatch(notificationActions.changeNotification({show: false, text: "", type: ""}))
                    }, 4000);
                })
        }
    }

    useEffect(() => {
        setLoading(true);
        axios.get(`/api/boats?limit=${filter.limit}&page=${filter.page}&keyword=${filter.keyword}&asc=${filter.asc}&status=${filter.status}&sort_by=${filter.sort_by}`)
            .then((res) => {
                setLoading(false);
                setBoats(res.data.data);
                const fromItems = ((filter.page - 1) * filter.limit) + 1;
                const toItems = res.data.total < filter.page * filter.limit ? res.data.total :  filter.page * filter.limit;
                const pagesCount = res.data.total % filter.limit === 0 ? res.data.total / filter.limit : parseInt((res.data.total / filter.limit) + 1);
                setPaginator({from: fromItems, to: toItems, total: res.data.total, pages: pagesCount});
            })
            .catch((err) => {

            })
    }, [filter, createdBoatsCount]);
    return (
        <div className="page-content-main-container">
            <h2 className="page-title">{t("boats.title")}</h2>
            <div className="table-filter-container">
                <button className='btn btn-primary' style={{display: "flex", alignItems: "center", marginRight: "15px"}} onClick={() => {
                    setShowBoatsModal(true);
                    setFormData({name: "", surname: "", superviser_fee: "", email: "", username: "", phone: "", password: "", calculator_category: "", role: "", identity_number: ""});
                    setActionType("add");
                }}><Plus style={{fontSize: "20px", fontWeight: "bold"}} /> <span>{t("common.addNew")}</span></button>
                <ViewToggle view={view} setView={setView} isMobile={isMobile} />
                <div className='search-by-keyword'>
                    <input placeholder={t("common.search")} type='text' onKeyDown={(e) => {
                        if(e.keyCode === 13){
                            setFilter((prev) => ({...prev, keyword: keyword}));
                        }
                    }} value={keyword} className='form-control' onChange={(e) => setKeyword(e.target.value)} />
                    <button onClick={() => setFilter((prev) => ({...prev, keyword: keyword}))}><Search /></button>
                </div>
            </div>
            {view === "table" ? (
            <Table responsive>
                <thead>
                    <tr>
                        <th>{t("boats.id")}</th>
                        <th>{t("boats.name")}</th>
                        <th>{t("boats.identificationCode")}</th>
                        <th>{t("boats.estDepartureDate")}</th>
                        <th>{t("boats.estArrivalDate")}</th>
                        <th>{t("boats.arrivalDate")}</th>
                        <th>{t("boats.status")}</th>
                        <th></th>
                    </tr>
                </thead>
                <tbody>
                    {
                        loading && <tr><td colSpan={8}><div style={{display: "flex", justifyContent: "center", alignItems: "center"}}><div className="loader" role=""></div></div></td></tr>
                    }
                    {
                        (boats.length > 0 && !loading) && boats.map((boat) => {
                            return(
                                <tr key={boat.identification_code}>
                                    <td>{boat.id}</td>
                                    <td>{boat.name}</td>
                                    <td>{boat.identification_code}</td>
                                    <td>{boat.departure_date == null ? t("table.notDefined") : core.formdatDate(boat.departure_date, "yyyy-mm-dd")}</td>
                                    <td>{boat.estimated_arrival_date == null ? t("table.notDefined") : core.formdatDate(boat.estimated_arrival_date, "yyyy-mm-dd")}</td>
                                    <td>{boat.arrival_date == null ? t("table.notDefined") : core.formdatDate(boat.arrival_date, "yyyy-mm-dd")}</td>
                                    <td>{boat.status.replaceAll("_", " ")}</td>
                                    <td>{rowActions(boat)}</td>
                                </tr>
                            )
                        })
                    }
                    {
                        (!loading && boats.length === 0) && <tr><td colSpan={8} style={{textAlign: "center"}}>{t("table.notFound")}</td></tr>
                    }
                </tbody>
            </Table>
            ) : (
                <DataCards layout={view}
                    items={loading ? [] : boats}
                    loading={loading}
                    getKey={(boat) => boat.identification_code}
                    renderTitle={(boat) => boat.name}
                    renderSubtitle={(boat) => boat.identification_code}
                    fields={cardFields}
                    renderActions={(boat) => rowActions(boat)}
                />
            )}
            <div className="pagination-container">
                <div className="paginatior-left-size">
                    <p className="showing-items-text">{t("table.showing")} {paginator.from} {t("table.of")} {paginator.to}</p>
                    <span style={{margin: "0 12px"}}>{t("table.total")}: {paginator.total}</span>
                    <span>{t("table.show")}:</span>
                    <select value={filter.limit} onChange={(e) => setFilter((prev) => ({...prev, limit: e.target.value}))} className="form-control" style={{width: "50px"}}>
                        <option value={10}>10</option>
                        <option value={20}>20</option>
                        <option value={30}>30</option>
                        <option value={50}>50</option>
                    </select>
                </div>
                <Stack spacing={2}>
                    <Pagination count={paginator.pages} page={filter.page} onChange={(value, p) => setFilter((prev)=>({...prev, page: p}))} />
                </Stack>
            </div>
            <CreateBoat show={showBoatsModal} setShow={setShowBoatsModal} formData={formData} setFormData={setFormData} submit={handlers.createBoat} loading={loadingCreateBoat} type={actionType} />
            <Modal show={showConfirmationModal} onHide={() => setShowConfirmationModal(false)} >
                <Modal.Header closeButton><h3>{t("boats.removeTitle")}</h3></Modal.Header>
                <Modal.Body><p>{t("boats.removeConfirm")}</p></Modal.Body>
                <Modal.Footer>
                    <Button type='button' onClick={handlers.deleteBoat} variant={loadingCreateBoat ? 'secondary' : 'primary'} disabled={loadingCreateBoat}>{loadingCreateBoat ? <div className="spinner-border spinner-border-sm" role="status" aria-hidden="true"></div> : t("common.yes")}</Button>
                    <Button type='button' onClick={() => setShowConfirmationModal(false)} variant='danger'>{t("common.no")}</Button>
                </Modal.Footer>
            </Modal>
        </div>
    );
}

export default Boats;